if (!customElements.get('planted-language-switcher')) {
  class PlantedLanguageSwitcher extends HTMLElement {
    connectedCallback() {
      if (!Weglot.initialized) {
        Weglot.on('initialized', this.setup.bind(this))
      } else {
        this.setup()
      }
    }

    setup() {
      const langEl = this.querySelector('[data-language]')
      const optionsEl = this.querySelector('ul[data-languages]')

      //Create array of options to be added
      const availableLanguages = Weglot.options.languages
        .map(function (language) {
          return language.language_to
        })
        .concat(Weglot.options.language_from)

      var currentLang = Weglot.getCurrentLang()

      const useFullname = this.hasAttribute('data-fullname')
      if (useFullname) {
        langEl.textContent = Weglot.getLanguageName(currentLang)
      } else {
        langEl.textContent = currentLang
      }

      langEl.textContent = currentLang
      //Create and append the options
      for (var i = 0; i < availableLanguages.length; i++) {
        const lang = availableLanguages[i]
        const option = document.createElement('li')
        option.setAttribute('data-lang', lang)
        if (useFullname) {
          option.textContent = Weglot.getLanguageName(lang)
        } else {
          option.textContent = lang
        }
        option.addEventListener('click', function (event) {
          Weglot.switchTo(event.target.getAttribute('data-lang'))
        })
        optionsEl.appendChild(option)
      }

      Weglot.on('languageChanged', function (lang) {
        if (useFullname) {
          langEl.textContent = Weglot.getLanguageName(lang)
        } else {
          langEl.textContent = lang
        }
      })
    }
  }
  customElements.define('planted-language-switcher', PlantedLanguageSwitcher)
}
